var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full text-error flex"},[_c('div',{staticClass:"pt-2 px-2 icon"},[_vm._t("icon",function(){return [_c('icon',{attrs:{"slot":"icon","name":"remove"},slot:"icon"})]})],2),_c('div',{staticClass:"pt-2 pl-0 text-14 text"},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }